
import React from 'react';
import { RadioGroupItem } from '@/components/ui/radio-group';

interface RadioFrequencyOptionProps {
  questionId: string;
  value: string;
  label: string;
}

const RadioFrequencyOption: React.FC<RadioFrequencyOptionProps> = ({ 
  questionId,
  value,
  label 
}) => {
  return (
    <div key={value} className="flex items-center">
      <RadioGroupItem
        value={value}
        id={`${questionId}-${value}`}
        className="peer sr-only"
      />
      <label
        htmlFor={`${questionId}-${value}`}
        className="flex items-center justify-center rounded-md border-2 border-muted bg-popover px-3 py-2 text-sm font-medium ring-offset-background transition-colors hover:bg-muted hover:text-muted-foreground peer-data-[state=checked]:border-[#e27d5f] peer-data-[state=checked]:text-[#e27d5f] cursor-pointer"
      >
        {label}
      </label>
    </div>
  );
};

export default RadioFrequencyOption;
